export default "__VITE_ASSET__B4AU8vFd__"